/*eslint-disable */
define(["jquery", "common/analytics/google-analytics"], function ($, ga) {
    function addListeners() {
        $(document).on("pageshow", "[data-role='page']", function() {
            var $page = $(this);
            var uri = $page.data("ga-pageview-uri");

            if (uri) {
                ga.trackPageViewWithUtm(uri);
                $(document).trigger("gapageviewed");
            }

            // Pages without a trackPageView URI are responsible for calling ga.trackPageView themselves.
            // This is typically done in a view's render function (where additional values can be
            // used from the model.
        });
    }

    return {
        addListeners: addListeners
    };
});
